<template>
  <EmarsysForm
    v-if="mgnlProps.switchable.field === 'emarsys'"
    :form1="mgnlProps.form1"
    :form2="mgnlProps.form2"
    :form3="mgnlProps.form3"
    :switchable="mgnlProps.switchable"
  />
  <SaleForceForm
    v-if="mgnlProps.switchable.field === 'saleforce'"
    :form1="mgnlProps.form1"
    :form2="mgnlProps.form2"
    :form3="mgnlProps.form3"
    :switchable="mgnlProps.switchable"
  />
</template>

<script lang="ts" setup>
import { WrapperProps, FormBuilder } from './Form.model';
import EmarsysForm from './EmarsysForm.vue';
import SaleForceForm from './SaleForceForm.vue';

const props = defineProps(WrapperProps);
const mgnlProps = computed(() => {
  return {
    ...FormBuilder.build(props),
    switchable: {
      ...props.switchable,
      subjectOptions: (() => {
        const raw = props.switchable?.subjectOptions;
        if (!raw) {
          return [];
        }
        if (Array.isArray(raw)) {
          return raw;
        }

        try {
          return Object.keys(raw)
            .filter(k => /subjectOptions(\d+)$/i.test(k))
            .map((k) => {
              const m = k.match(/subjectOptions(\d+)$/i);
              const idx = m ? Number(m[1]) : Number.POSITIVE_INFINITY;
              return { idx, val: (raw as any)[k] };
            })
            .sort((a, b) => a.idx - b.idx)
            .map(x => x.val);
        }
        catch {
          return Object.values(raw as any);
        }
      })(),
    },
  };
});
</script>
